import styled from 'styled-components';

export const Content = styled.div`
  padding: 20px;
`;

export const Message = styled.p`
  font-family: Blinker;
  font-size: 16px;
  line-height: 22px;
  color: #4d4d4d;
  margin: 0;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 12px;
  padding: 0 20px 20px;

  button {
    min-width: 120px;
  }
`;
